module.exports = __webpack_public_path__ + "./docs/img/httpapi.ea725faf5b15813a1aebc5c18941472e.svg";